import { render, staticRenderFns } from "./FieldReference.vue?vue&type=template&id=236a0433&scoped=true"
import script from "./FieldReference.vue?vue&type=script&lang=js"
export * from "./FieldReference.vue?vue&type=script&lang=js"
import style0 from "./FieldReference.vue?vue&type=style&index=0&id=236a0433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a0433",
  null
  
)

export default component.exports